import React from 'react';
import './styles.scss';

const TooltipIcon = ({ icon = 'fas fa-question-circle', ...props }) => {

  const tooltipProps = {
    'data-toggle': 'tooltip',
    ...props
  }

  return (
    <span>
      <i className={`${icon} swa-tooltip-wrapper`} {...tooltipProps}></i>
    </span>
  );
}

export default TooltipIcon;
